import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import ControlPanelPage from './pages/ControlPanelPage';
import PortfolioSite from './portfolio/PortfolioSite';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/control/*" element={<ControlPanelPage />} />
          <Route path="*" element={<PortfolioSite />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
